import { FareEstimateSecureErrorApiModel } from '../api-models/FareEstimateSecureErrorApiModel';
import { FareEstimateSecureError } from '../entities/FareEstimateSecureError';

export function toFareEstimateSecureError(
  response: FareEstimateSecureErrorApiModel,
): FareEstimateSecureError {
  return {
    status: response.status,
    error: response.error,
  };
}
